/* Generated by TinySVG. Do not edit directly. */
import type { TinyIconProps } from '../types.ts'

export function ApartmentFilledIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth,
  title,
  ...svgProps
}: TinyIconProps) {
  const resolvedStrokeWidth = strokeWidth ?? 1.75
  const scaledStrokeWidth = (percent: number) => {
    const numericStrokeWidth = typeof resolvedStrokeWidth === 'number' ? resolvedStrokeWidth : Number(resolvedStrokeWidth)
    return Number.isFinite(numericStrokeWidth) ? numericStrokeWidth * percent / 100 : resolvedStrokeWidth
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      strokeWidth={resolvedStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      data-icon="apartment-filled"
      data-variant="outline"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
          <path d="M4.5 21.5L4.5 4.5L4.505 4.363L4.518 4.229L4.541 4.097L4.571 3.968L4.61 3.843L4.657 3.722L4.711 3.604L4.773 3.491L4.842 3.382L4.917 3.278L4.998 3.179L5.086 3.086L5.179 2.998L5.278 2.917L5.382 2.842L5.491 2.773L5.604 2.711L5.722 2.657L5.843 2.61L5.968 2.571L6.097 2.541L6.229 2.518L6.363 2.505L6.5 2.5L13 2.5L13.137 2.505L13.271 2.518L13.403 2.541L13.532 2.571L13.657 2.61L13.778 2.657L13.896 2.711L14.009 2.773L14.118 2.842L14.222 2.917L14.321 2.998L14.414 3.086L14.502 3.179L14.583 3.278L14.658 3.382L14.727 3.491L14.789 3.604L14.843 3.722L14.89 3.843L14.929 3.968L14.959 4.097L14.982 4.229L14.995 4.363L15 4.5L15 21.5L11.25 21.5L11.25 19C11.25 18.586 10.914 18.25 10.5 18.25L9 18.25C8.586 18.25 8.25 18.586 8.25 19L8.25 21.5L4.5 21.5ZM7.25 6L7.25 9C7.25 9.414 7.586 9.75 8 9.75C8.414 9.75 8.75 9.414 8.75 9L8.75 6C8.75 5.586 8.414 5.25 8 5.25C7.586 5.25 7.25 5.586 7.25 6ZM10.75 6L10.75 9C10.75 9.414 11.086 9.75 11.5 9.75C11.914 9.75 12.25 9.414 12.25 9L12.25 6C12.25 5.586 11.914 5.25 11.5 5.25C11.086 5.25 10.75 5.586 10.75 6ZM7.25 12.5L7.25 15.5C7.25 15.914 7.586 16.25 8 16.25C8.414 16.25 8.75 15.914 8.75 15.5L8.75 12.5C8.75 12.086 8.414 11.75 8 11.75C7.586 11.75 7.25 12.086 7.25 12.5ZM10.75 12.5L10.75 15.5C10.75 15.914 11.086 16.25 11.5 16.25C11.914 16.25 12.25 15.914 12.25 15.5L12.25 12.5C12.25 12.086 11.914 11.75 11.5 11.75C11.086 11.75 10.75 12.086 10.75 12.5Z" data-tinysvg-shape="compound-path" fillRule="evenodd" stroke="none" fill={color} data-fill-tone="primary" />
          <path d="M4.5 21.5L4.5 4.5C4.5 3.395 5.395 2.5 6.5 2.5L13 2.5C14.105 2.5 15 3.395 15 4.5L15 21.5" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M15 8.53L17.487 8.513C18.596 8.506 19.5 9.404 19.5 10.513L19.5 21.5" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M2.5 21.5L21.5 21.5" data-tinysvg-shape="line" stroke={color} fill="none" data-stroke-tone="primary" />
    </svg>
  )
}
